module.exports = __webpack_public_path__ + "img/icon-10percent.e0720592.svg";